<template>
  <div class="rule-wrap">
    <p class="title bold">解锁规则说明</p>
    <p>
      <span class="bold">1. 解锁券获取方式：</span
      >成为付费会员，即可获得五张解锁券，其中包含三张点金解锁券与两张课程解锁券。
    </p>
    <p>
      <span class="bold"> 2. 点金解锁券使用说明：</span>
      点金解锁券仅适用于点金产品的解锁。在解锁券的详情页面选择点金解锁券，点击解锁点金详情页面，在您浏览到心仪的点金产品时，选择使用点金解锁券，即可成功解锁该产品其中点金包中的一条点金内容，如若想畅享该点金内的全部内容可继续订阅点金。每张点金解锁券仅能使用一次，且不可叠加使用
      ，一张券对应解锁一个点金产品中的任一一条点金内容。
    </p>
    <p>
      <span class="bold">3. 课程解锁券使用说明：</span
      >课程解锁券专门用于课程产品的解锁。在解锁券的详情页面选择课程解锁券进入解锁课程页面，当您挑选好想要学习的课程包后，进入该课程包详情页，选择其中一集课程，选择播放按钮即可解锁。如若想畅享该课程包中的全部内容可继续订阅课程。同样，每张课程解锁券仅能使用一次，两张券可分别用于解锁不同的课程内容，无法重复解锁同一集课程
      。
    </p>
    <p>
      <span class="bold">4. 解锁券有效期：</span
      >解锁券自您成为付费会员之日起生效，每张解锁券的有效期会显示在解锁券的页面中，请在有效期内使用，逾期未使用的解锁券将自动作废
      ，且无法进行补发或退换。
    </p>
    <p>
      <span class="bold"> 5、解锁后的权益回看：</span
      >解锁后的点金、课程对应的那节自解锁后均可回看
    </p>
    <p>
      <span class="bold">6. 特别提示：</span
      >解锁券是会员专属福利，严禁任何形式的转让、售卖或违规使用。如发现有违反规定的行为，我们有权收回解锁券，并对账号进行相应处理
      。若在使用解锁券过程中遇到任何问题，请随时联系我们的客服人员，我们将竭诚为您服务
      。
    </p>
    <p>解释权归第一财经有看投所有</p>
  </div>
</template>
<script>
export default {
  name: 'unlockRule'
}
</script>

<style scoped lang="scss">
.rule-wrap {
  padding: 20px;
  p {
    font-size: 28px;
    line-height: 1.58;
    color: #333;
    margin-bottom: 20px;
  }
  .title {
    font-size: 32px;
  }
  .bold {
    font-weight: bold;
    display: block;
  }
}
</style>
